module.exports = __webpack_public_path__ + "img/en.056323bc.png";